import {
  Component,
  OnInit,
  HostListener,
  Inject,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import * as  LZString from 'lz-string';
import { CustomerInformation } from 'src/app/Interfaces/customer-information';
import {
  BehaviorSubject,
  Observable,
  combineLatest,
  Subject,
  of,
  from,
  observable,
} from 'rxjs';
import {
  startWith,
  map,
  takeUntil,
  catchError,
  mergeMap,
  tap,
} from 'rxjs/operators';
import { Companies, CompanyVersion } from './companies';
import { hebrewDictionary } from 'src/app/services/util.service';
import { ExcelService } from 'src/app/services/excel.service';

type SortColumns = 'CustName' | 'CustNum' | 'LastPoll' | 'sslTokef';

@Component({
  selector: 'app-dashbord',
  templateUrl: './dashbord.component.html',
  styleUrls: ['./dashbord.component.scss'],
})
export class DashbordComponent implements OnInit, OnDestroy {
  showLogoutPopup = false;
  burgerMenu = false;
  burgerMenuNoScroll = false;
  headerAbsolute = false;
  windowWidth = innerWidth;

  public AllCompaniesSave;

  public CompanyVersionAll;

  public section1 = false;

  public section2 = true;

  Companies = Companies;
  CompanyVersion = CompanyVersion;

  translateEnglishCharactersToHebrew$ = new BehaviorSubject(false);
  buttonMessage$ = this.translateEnglishCharactersToHebrew$.pipe(
    map((value) => (value ? 'בטל תרגום' : 'תרגם אנגלית לעברית'))
  );

  constructor(
    public _ss: StoreService,
    public router: Router,
    public _fb: FormBuilder,
    public _excel: ExcelService
  ) {}

  public form = this._fb.group({
    Name: ['', Validators.required],
    User: ['', Validators.required],
    Pass: ['', Validators.required],
  });

  customersDisplay$: Observable<CustomerInformation[]>;
  totalCustomers$ = this._ss.customers$.pipe(
    map((customers) => customers.length)
  );
  sortOrder$ = new BehaviorSubject<
    { key: string; order: 'asc' | 'desc' | null }[]
  >([
    {
      key: 'CustName',
      order: 'asc',
    },
    {
      key: 'CustNum',
      order: null,
    },
    {
      key: 'LastPoll',
      order: null,
    },
  ]);
  allSQLColumns$: Observable<string[]>;
  destroy$ = new Subject<void>();

  readonly acceptableTimeRange = 1000 * 60 * 7 * 4; // missed 4 polls
  readonly currentTimestamp = new Date().getTime();

  async ngOnInit() {
    if (localStorage.getItem('log') !== null) {
      this.section1 = true;
      this.section2 = false;
    }

    if (localStorage.getItem('translate')) {
      this.translateEnglishCharactersToHebrew$.next(
        JSON.parse(localStorage.getItem('translate')) as boolean
      );
    }

    this.CompanyVersionAll = this.CompanyVersion;

    console.log(this.CompanyVersion);

    window.scrollTo(0, 0);

    if (!this._ss.customers$.value.length) {
      await new Promise<void>((resolve) => {
        this._ss.GetAllMobilityClients().subscribe(
          (res) => {
            console.log(res);

            if (typeof res != 'string') {
              if (!res.recordset.length) {
                alert('אין נתונים להביא');
              } else {
                this._ss.customers$.next(res.recordset);
              }
            } else {
              alert('תקלה בהבאת נתונים');
            }
            resolve();
          },
          (err) => {
            alert('תקלה בהבאת נתונים');
            resolve();
          }
        );
      });
    }

    this.setupSearchInteractivity();

    this.Companies.sort(function (a, b) {
      return b.version - a.version;
    });

    for (let x = 0; x < this.Companies.length; x++) {
      this.Companies[x].order = x + 1;
    }

    this.AllCompaniesSave = this.Companies;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public Login() {
    if (
      this.form.controls.User.value === 'אסף' ||
      this.form.controls.User.value === 'ירון'
    ) {
      if (this.form.controls.Pass.value === '12321') {
        this.section1 = true;
        this.section2 = false;
        localStorage.setItem('log', 'true');
      }
    }
  }
  public Restart() {
    window.location.reload();
  }
  public MoveToDashbord(customer) {
    this._ss.CustomerInformation = customer;

    this.router.navigate(['mobilitydashbord', customer.CustNum]);
  }

  sortMain(key: SortColumns) {
    const order = this.sortOrder$.value.find((item) => item.key === key).order;

    this.sortOrder$.next(
      this.sortOrder$.value.map((item) => {
        if (item.key === key) {
          return {
            ...item,
            order: order === 'asc' ? 'desc' : 'asc',
          };
        }

        return {
          ...item,
          order: null,
        };
      })
    );
  }

  public CustInfo(customer) {
    this._ss.CustomerChoose = customer;

    // this._ss.Customers = this.Customers;
    this.router.navigate(['edit']);
  }

  showHideMenu(value: boolean): void {
    this.burgerMenu = value;

    if (value) {
      this.headerAbsolute = value;
      this.burgerMenuNoScroll = value;
    } else {
      setTimeout(() => {
        this.headerAbsolute = value;
        this.burgerMenuNoScroll = value;
      }, 1000);
    }
  }

  showHideLogoutPopup(value: boolean): void {
    this.showLogoutPopup = value;
  }

  setupSearchInteractivity() {
    const searchValue$ = this.form.controls.Name.valueChanges.pipe(
      startWith('')
    );

    this.allSQLColumns$ = this._ss.customers$.pipe(
      map((allCustomers) => Object.keys(allCustomers))
    );

    this.customersDisplay$ = combineLatest([
      this._ss.customers$,
      searchValue$,
      this.sortOrder$,
    ]).pipe(
      map(
        ([allCustomers, searchValue, sortOrder]: [
          CustomerInformation[],
          string,
          { key: string; order: 'asc' | 'desc' | null }[]
        ]) => {
          let filteredValues = [...allCustomers];
          const stringSearchArray: any[] = [];

          if (searchValue) {
            if (this.translateEnglishCharactersToHebrew$.value) {
              searchValue = [...searchValue]
                .map((letter) => hebrewDictionary[letter] ?? letter)
                .join('')
                .toLowerCase();
            }

            const splitValue = searchValue.split(' ');

            for (let i = 0; i < filteredValues.length; i++) {
              let counter = 0;

              const { CustNum, CustName } = filteredValues[i];

              const CustNumWithoutSpaces = (CustNum || '')
                  .replace(/\s/g, '')
                  .toLowerCase(),
                CustNameWithoutSpaces = (CustName || '')
                  .replace(/\s/g, '')
                  .toLowerCase(),
                allStrings =
                  typeof CustNumWithoutSpaces === 'string' &&
                  typeof CustNameWithoutSpaces === 'string';

              // V8 optimizes this if statement, maybe
              if (allStrings) {
                for (let j = 0; j < splitValue.length; j++) {
                  if (
                    (CustNumWithoutSpaces &&
                      CustNumWithoutSpaces.indexOf(splitValue[j]) > -1) ||
                    (CustNameWithoutSpaces &&
                      CustNameWithoutSpaces.indexOf(splitValue[j]) > -1)
                  ) {
                    counter++;
                  }
                }

                if (counter >= splitValue.length) {
                  stringSearchArray.push(filteredValues[i]);
                }
              }
            }

            filteredValues = stringSearchArray;
          }

          for (let i = 0; i < sortOrder.length; i++) {
            const { key, order } = sortOrder[i];

            if (order) {
              filteredValues = filteredValues.sort((a, b) => {
                const aValue = a[key],
                  bValue = b[key];

                if (aValue === bValue) {
                  return 0;
                }

                if (order === 'asc') {

                  return Intl.Collator('he').compare(aValue, bValue);
                } else {
                  return Intl.Collator('he').compare(bValue, aValue);
                }
              });
            }
          }

          return filteredValues;
        }
      )
    );
  }

  changeSubjectBooleanValue() {
    const nextValue = !this.translateEnglishCharactersToHebrew$.value;
    localStorage.setItem('translate', String(nextValue));
    this.translateEnglishCharactersToHebrew$.next(nextValue);
  }

  hasServerReceivedResponseInAcceptableTime(date: Date | string): boolean {
    return (
      this.currentTimestamp - this.translateDate(date, 'fromSQL').getTime() <
      this.acceptableTimeRange
    );
  }

  translateDate(date: string | Date, quantifier: 'toSQL' | 'fromSQL'): Date {
    switch (quantifier) {
      case 'toSQL':
        return new Date(
          new Date(date).getTime() -
            new Date(date).getTimezoneOffset() * 1000 * 60
        );
      case 'fromSQL':
        return new Date(
          new Date(date).getTime() +
            new Date(date).getTimezoneOffset() * 1000 * 60
        );

      default:
        return new Date(date);
    }
  }
}
